import { For, Show } from "solid-js";
import type { ClassList } from "../../../../types";
import { useVisibleBanners, useDismissBanner } from "../../banner/banners";
import { isEmpty } from "lodash-es";
import { QueryBoundary } from "../../../../utils/QueryBoundary";

type SidebarBannerSectionProps = {
  classList?: ClassList;
};

const SidebarBannerSection = (props: SidebarBannerSectionProps) => {
  const visibleBanners = useVisibleBanners();
  const dismissBanner = useDismissBanner();

  return (
    <Show when={!isEmpty(visibleBanners())}>
      <div class="mt-auto flex flex-col gap-y-2 border-t border-subtle py-4" classList={props.classList}>
        <For each={visibleBanners()}>
          {(banner) => (
            <QueryBoundary errorFallback={<></>} loadingFallback={<></>}>
              <banner.Component onDismiss={banner.dismissable ? () => dismissBanner(banner.id) : undefined} />
            </QueryBoundary>
          )}
        </For>
      </div>
    </Show>
  );
};

export default SidebarBannerSection;
